document.addEventListener('alpine:init', () => {
  Alpine.store('nav', {
    currentIndex: 1,
    activeMegamenu: '',
    /**
     * Handle of the currently hovered L2 item inside the active panel.
     * Drives the absolute-overlay L3 list and per-L2 promo image swaps.
     * Cleared whenever the active L1 panel changes or the megamenu closes.
     */
    activeSubmenu: '',

    syncMegamenuOpenClass() {
      document.documentElement.classList.toggle(
        'megamenu-open',
        Boolean(this.activeMegamenu)
      );
    },

    openMegamenu(handle) {
      if (this.activeMegamenu !== handle) this.activeSubmenu = '';
      this.activeMegamenu = handle;
      this.syncMegamenuOpenClass();
    },

    toggleMegamenu(handle) {
      const next = this.activeMegamenu === handle ? '' : handle;
      if (next !== this.activeMegamenu) this.activeSubmenu = '';
      this.activeMegamenu = next;
      this.syncMegamenuOpenClass();
    },

    closeMegamenu() {
      this.activeMegamenu = '';
      this.activeSubmenu = '';
      this.syncMegamenuOpenClass();
    },

    openSubmenu(handle) {
      this.activeSubmenu = handle;
    },

    clearSubmenu() {
      this.activeSubmenu = '';
    },
  });
});
